// global.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GlobalVariablesService {
  public SETTING_USER_ROLES: any = null;
  public SETTING_BUSINESS_TYPES: any = null;
  public SETTING_CREDIT_TERMS: any = null;
  public SETTING_FINANCIAL_RATINGS: any = null;
  public SETTING_TRUCK_TYPES: any = null;
  public SETTING_TRUCK_MODEL_NUMBERS: any = null;
  public SETTING_TRUCK_LOADING_CAPACITY: any = null;
  public SETTING_BOX_SIZE: any = null;
  public SETTING_BOX_LOADING_TYPES: any = null;
  public SETTING_VEHICLE_MAINTENANCE: any = null;
  public SETTING_INCIDENT_REPORT: any = null;
  public SETTING_ROUTE_EXPERTISE: any = null;
  public SETTING_INSURANCE_TYPES: any = null;
  public SETTING_SECURITY_DEPOSIT_AMOUNT: any = null;
  public SETTING_QUANTITY_TYPES: any = null;
  public SETTING_HANDLING_METHODS: any = null;
  public SETTING_DIMENSION: any = null;
  public ORDER_BOOKING_STATUS: any = null;
  public YEAR_MADE: any = null;
  public TRUCK_STATUS: any = null;
  public PACKAGING_TYPES: any = null;
  public TEMPERATURE_CONTROL: any = null;
  public TRACKING_STATUS: any = null;
  public HANDLING_TYPES: any = null;
  public isLoggedIn: boolean = false;

  constructor() {}
}
